import React, { useState } from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'


const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: [],
  states: []
}

export default function Slider(props) {
  let {
    onChange,
    min,
    max,
    value,
    step,
    disabled,
    id,
    parentClassName,
    ...rest
  } = props

  const [sliderValue, setSliderValue] = useState(value)


  min = min || 0
  max = max || 100
  step = step || 1
  value = value || min
  onChange = onChange || function () {}

  const handleChange = (event) => {
    const value = event.target.value

    setSliderValue(value)
  }
  const renderPercentage = (min, max) => {
    const percentage = ((sliderValue - min) * 100) / (max - min)
    return percentage
  }
  const sliderValuePercentage = renderPercentage(min, max, sliderValue) + '%'

  const renderSlider = (props, step, min, max, onChange, disabled) => {
    const sliderValueBar = renderPercentage(min, max, sliderValue) + '%'
    return (
      <div className="mdn-Slider-contentBar">
        <span
          className="mdn-Slider-barRange"
          style={{ width: sliderValueBar }}
          htmlFor={id}
        ></span>
        <input
          {...rest}
          className="mdn-Slider-bar"
          type="range"
          value={sliderValue}
          step={step}
          min={min}
          max={max}
          disabled={disabled}
          onChange={(evt) => {
            handleChange(evt)
            onChange(evt, evt.target.value)
          }}
        />
      </div>
    )
  }

  return (
    <div
      className={`${resolveProps(props, config, 'Slider')}  ${parentClassName}`}
      disabled={disabled}
    >
      <div className="mdn-Slider-percent">
        <p
          className="mdn-Slider-percentText mdn-Heading"
          style={{
            left: sliderValuePercentage,
            transform: `translateX(-${sliderValuePercentage})`
          }}
        >
          {sliderValue}
        </p>
        <p className="mdn-Slider-percentText--init mdn-Heading">{min}</p>
        <p className="mdn-Slider-percentText--final mdn-Heading">{max}</p>
      </div>
      {renderSlider(props, step, min, max, onChange, disabled)}
    </div>
  )
}

Slider.propTypes = {
  onChange: PropTypes.func,
  parentClassName: PropTypes.string,
  config: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool
}
